module.exports = __webpack_public_path__ + "static/media/security-green.4897599d.png";